function state() {
  return {
    renewal: {},
    renewals: [],
    renewalsMeta: {},
    partners: [],
    productCategories: [],
  };
}

export default state;
